import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { currentUrl } from "../../url"

// Токен будет читаться при каждом запросе, а не при загрузке модуля

type City = {
  id: number
  country_id: number
  name: string
}

type CitiesState = {
  cities: City[]
  citiesLoading: boolean
  citiesError: boolean
}

export const fetchCities = createAsyncThunk<
  City[],
  undefined,
  { rejectValue: boolean }
>("cities/fetchCities", async function (_, { rejectWithValue }) {
  try {
    // Читаем токен при каждом запросе, чтобы использовать актуальное значение
    const accessToken = localStorage.getItem("accessToken");

     if (!accessToken) {
      return rejectWithValue(true); // Если токена нет, возвращаем ошибку
    }

    // Убеждаемся, что токен имеет правильный формат (Bearer префикс)
    const token = accessToken.startsWith("Bearer ") 
      ? accessToken 
      : `Bearer ${accessToken}`

    const res = await fetch(`${currentUrl}/master/cities`, {
      headers: {
        Authorization: token,
      },
    })

    if (!res.ok) {
      return rejectWithValue(true); // Если запрос завершился с ошибкой
    }
    const data = await res.json()

    const processedCities: City[] = data.map(
      (item: { id: number; country_id: number; name: string }): City => ({
        id: item.id,
        country_id: item.country_id,
        name: item.name,
      })
    )

    return processedCities
  }catch (err) {
    return rejectWithValue(true); // Ловим все исключения
  }
})

const initialState: CitiesState = {
  cities: [],
  citiesError: false,
  citiesLoading: true
}

const citiesSlice = createSlice({
  name: 'citiesSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCities.pending, (state) => {
        state.citiesLoading = true
        state.citiesError = false
      })
      .addCase(fetchCities.fulfilled, (state, action) => {
        state.cities = action.payload
        state.citiesLoading = false
        state.citiesError = false
      })
      .addCase(fetchCities.rejected, (state) => {
        state.citiesError = true
      })
  }
})

export default citiesSlice.reducer
